
import { Card } from '@/components/ui/card';
import AdvancedAnalysisButton from './AdvancedAnalysisButton';
import PreviousResultsButton from './PreviousResultsButton';

interface BigFiveAdvancedAnalysisSectionProps {
  savedResultId: string;
  testResults: any;
  onAnalysisComplete: (analysis: any, insight: any) => void;
}

export default function BigFiveAdvancedAnalysisSection({ 
  savedResultId, 
  testResults, 
  onAnalysisComplete 
}: BigFiveAdvancedAnalysisSectionProps) {
  return (
    <Card className="p-6 bg-gradient-to-r from-purple-50 to-blue-50 border-purple-200">
      <div className="space-y-4">
        <h3 className="text-xl font-semibold text-purple-800">
          Análise Psicológica Avançada
        </h3>
        <p className="text-gray-700 max-w-2xl">
          Obtenha insights profundos sobre sua personalidade com nossa análise avançada 
          baseada em IA. Inclui análise psiquiátrica, psicanalítica e recomendações 
          terapêuticas personalizadas.
        </p>
        
        <AdvancedAnalysisButton
          bigFiveResultId={savedResultId}
          testResults={testResults}
          onAnalysisComplete={onAnalysisComplete}
        />
        
        <div className="flex justify-center pt-2">
          <PreviousResultsButton />
        </div>
      </div>
    </Card>
  );
}
